import React from "react";
import { Container } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const Portfolio = (props) => {
  const projects = props.projects;
  return (
    <Container>
      <section id="portfolio" className="pt-5 px-5">
        <h3 className="mb-5">PORTFOLIO</h3>
        <Container>
          <Row>
            {projects.map((project) => (
              <Col lg={6} key={project.id} className="mb-4">
                <div className="img-wrapper">
                  <img
                    src={project.img}
                    alt={project.title}
                    width="100%"
                    height="250px"
                  />
                  <div className="img-caption">
                    <Link to={`/portfolio/project-details/${project.params}`}>
                      <h3 className="p-3" style={{ border: "3px solid white" }}>
                        SHOW DETAILS
                      </h3>
                    </Link>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </Container>
  );
};

export default Portfolio;
